export enum LeaderCriteriaTableColumns {
  Name = "name",
  LeaderCriteriaId = "leaderCriteriaId",
}
